import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import App from './App.vue';
import router from '../router';
import vuetify from '../plugins/vuetify';
import store from '../store';

Vue.config.productionTip = false;

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

new Vue({
  router,
  vuetify,
  store,
  pinia,
  render: (h) => h(App),
}).$mount('#app');
